import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { ItemType } from "sprout-graphql";
import { useParams } from "react-router-dom";
import TopicPageHeader from "../TopicPageHeader";
import ActivityPageList from "../../ActivityPage/ActivityPageList";
const TopicPageViewsActivityMain = (props)=>{
    const { topicId  } = useParams();
    const subject = useMemo(()=>({
            id: Number(topicId),
            type: ItemType.Topic
        }), [
        topicId
    ]);
    const { topic , activities , loading , hasNextPage , loadMore  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageHeader, {
                topic: topic
            }),
            /*#__PURE__*/ _jsx(ActivityPageList, {
                subject: subject,
                loading: loading,
                activities: activities,
                loadMore: loadMore,
                hasNextPage: hasNextPage
            })
        ]
    });
};
export default TopicPageViewsActivityMain;
